import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import { QueryClientProvider } from 'react-query'

import { GlobalApplication } from '@features/globalApplication'
import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { queryClient } from '../../config/queryClient'
import { HistoryRouter } from '../../utils/HistoryRouter'

const MODULE_NAME = 'global-application-module'

class GlobalApplicationWebComponent extends DOMModel {
  @byAttrVal('organizationid') organizationId: string
}

interface GlobalApplicationModuleProps {
  organizationId: string
}

const GlobalApplicationModule = ({ organizationId }: GlobalApplicationModuleProps) => {
  // for /external_login path, we don't want to fetch the current user to allow for uninterrupted access token rotation
  const isExternalLogin = window.location.pathname.startsWith('/external_login/')

  return (
    <QueryClientProvider client={queryClient}>
      <CurrentUserContextProvider enabled={!isExternalLogin}>
        <UserOrganizationContextProvider organizationId={organizationId}>
          <HistoryRouter>
            <GlobalApplication />
          </HistoryRouter>
        </UserOrganizationContextProvider>
      </CurrentUserContextProvider>
    </QueryClientProvider>
  )
}

const RoutingHelperElement = createCustomElement(GlobalApplicationModule, GlobalApplicationWebComponent, 'element')

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, RoutingHelperElement)

export default RoutingHelperElement
